export const COMPANY_NAME_LENGTH = 60;
export const TOAST_ERROR_TIME = 5000;
export const TOAST_SUCCESS_TIME = 3000;
